import VolumeHighIcon from '@atlaskit/icon/core/volume-high';
import * as React from 'react';

export function SvgVolume2() {
  return <VolumeHighIcon label="" testId="ads-refreshed-icon" />;
}
